import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpEventType, HttpHeaders } from '@angular/common/http';
import { catchError, tap, map } from 'rxjs/operators';
import { ErrorHandlerService } from '../error-handler.service';
import { AnimationsService } from '../animations.service';
import { environment } from '../../../environments/environment';
import { API } from '../api';
import { AuthService } from 'src/app/security/auth.service';

@Injectable({
  providedIn: 'root'
})
export class ContratoAlunoService {

  constructor(
    private http: HttpClient,
    private animationsService: AnimationsService,
    private errorHandlerService: ErrorHandlerService,
    private authService: AuthService,
  ) { }

  gerarContrato(data): void {
    this.animationsService.showProgressBar(true);
    const usuario = this.authService.getToken();
    this.http.post(`${environment.baseUrl}${API.contrato.gerarContrato}`, data, {headers: new HttpHeaders().set('Authorization',  'Bearer '+ usuario?.token)})
      .pipe(
        catchError(this.errorHandlerService.errorHandlerAnexo('Falha ao baixar anexo', []))
      )
      .subscribe(res => {
        this.animationsService.showProgressBar(false);
        if (res?.status === 'error') return;
        const b64Data = res;
        const blob = this.b64toBlob(b64Data, 'application/pdf');
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'Contrato.pdf';
        link.click();
        this.animationsService.showProgressBar(false);
      });
  }

  uploadContrato(data) {
    this.animationsService.showProgressBar(true);
    const usuario = this.authService.getToken();
    return this.http.post<any>(`${environment.baseUrl}${API.contrato.uploadContrato}`, data, { reportProgress: true, observe: 'events' , headers: new HttpHeaders().set('Authorization',  'Bearer '+ usuario?.token)})
      .pipe(
        map((event) => {
          switch (event.type) {
            case HttpEventType.UploadProgress:
              // Uploading progress
              const progress = Math.round(100 * event.loaded / event.total);
              return { status: 'progress', progress };
            case HttpEventType.Response:
              // SnackBar success
              this.animationsService.showProgressBar(false);
              this.animationsService.showSuccessSnackBar('Enviado com sucesso');
              return { status: 'done', response: event.body };
            default:
              return;
          }
        }),
        catchError(this.errorHandlerService.errorHandler('Falha ao enviar anexo', []))
      );
  }

  download(id) {
    this.animationsService.showProgressBar(true);
    const params: HttpParams = new HttpParams().set('matriculaId', id);
    const usuario = this.authService.getToken();
    this.http.get(`${environment.baseUrl}${API.contrato.downloadContrato}`, { params , headers: new HttpHeaders().set('Authorization',  'Bearer '+ usuario?.token)})
      .pipe(
        tap(() => this.animationsService.showProgressBar(false)),
        catchError(this.errorHandlerService.errorHandlerAnexo('Falha ao baixar anexo', [])),
      )
      .subscribe(res => {
        if (res?.status === 'error') return;
        if(res) {
          const b64Data = res;
          const blob = this.b64toBlob(b64Data, 'application/pdf');
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = 'Contrato Assinado.pdf';
          link.click();
        } else {
          this.animationsService.showErrorSnackBar('Não possui declaração de pendência');
        }
      });
  }

  imprimir(id) {
    this.animationsService.showProgressBar(true);
    const params: HttpParams = new HttpParams().set('matriculaId', id);
    const usuario = this.authService.getToken();
    this.http.get(`${environment.baseUrl}${API.contrato.downloadContrato}`, { params , headers: new HttpHeaders().set('Authorization',  'Bearer '+ usuario?.token)})
      .pipe(
        tap(() => this.animationsService.showProgressBar(false)),
        catchError(this.errorHandlerService.errorHandlerAnexo('Falha ao imprimir anexo', []))
      )
      .subscribe(res => {
        if (res?.status === 'error') return;
        if(res) {
          const b64Data = res;
          const blob = this.b64toBlob(b64Data, 'application/pdf');
          const url = window.URL.createObjectURL(blob);
          window.open(url, '_blank');
        }else {
          this.animationsService.showSuccessSnackBar('Não possui declaração de pendência');
        }
      });
  }

  /**
   * @description Convert a base64 to Blob
   * @param b64Data Base64
   * @param contentType File's type
   * @param sliceSize Slice size
   * @returns Blob
   */
  private b64toBlob = (b64Data, contentType = '', sliceSize = 512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize ) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }
}
